import { getClientUuid } from '@/shared/lib/clientUuid';
import { createUuid } from '@/shared/lib/createUuid';
import { serializeQuery } from '@/shared/lib/serializeQuery';
import { getCurrentUrl } from '@/shared/lib/urlQuery';
import { getDeviceType, isMobileDevice } from './getDeviceType';
import { getSourcebusterData } from './sourcebuster';
import { getAppDownloadUtmQuery } from './utmQuery';
import { APPMETRICA_REDIRECT_URLS, DEFAULT_APP_DOWNLOAD_DEVICE_TYPE } from '../config/appDownload';
import { AppDownloadPartner, type AppDownloadOptions, type DeviceType } from '../model/types';

export function resolveAppDownloadDeviceType(deviceType?: DeviceType | null): DeviceType {
  return deviceType ?? getDeviceType() ?? DEFAULT_APP_DOWNLOAD_DEVICE_TYPE;
}

function getDefaultAppDownloadPartner(): AppDownloadPartner {
  return isMobileDevice() ? AppDownloadPartner.MobileWeb : AppDownloadPartner.Desktop;
}

export function getAppDownloadUrl({ bannerName, deviceType, partner }: AppDownloadOptions): string {
  const query = {
    click_id: createUuid(),
    rnd: Math.random(),
    partner: partner ?? getDefaultAppDownloadPartner(),
    utm_source: bannerName || undefined,
    ...getAppDownloadUtmQuery(getCurrentUrl(), getSourcebusterData()),
    client_uuid: getClientUuid() || undefined,
  };

  return `${APPMETRICA_REDIRECT_URLS[resolveAppDownloadDeviceType(deviceType)]}?${serializeQuery(query)}`;
}
